import script from "./WSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./WSettings.vue?vue&type=script&setup=true&lang=ts"

import "./WSettings.vue?vue&type=style&index=0&id=e755c218&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e755c218"]])

export default __exports__